import { ThemeName } from "@evergis/ui";

import { ThemeState } from "./types";

export const INITIAL_STATE: ThemeState = {
  themeName: ThemeName.Light,
};
